/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import I18n from 'I18n';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import PropTypes from 'prop-types';
import { Component } from 'react';
import debounce from 'react-utils/debounce';
import { LinkTypes } from '../../constants/link';
import { jsx as _jsx } from "react/jsx-runtime";
export default class PageLinkField extends Component {
  constructor(props) {
    super(props);
    this.fetchPublishedContent = debounce(this.fetchPublishedContent.bind(this), 200);
  }
  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  fetchPublishedContent(input, callback, pagination = {
    offset: 0
  }) {
    const {
      fetchPages
    } = this.props;
    fetchPages({
      term: input,
      offset: pagination.offset
    }).then(data => {
      if (!this.mounted) {
        return;
      }
      const parsedData = data.objects.map(asset => {
        return {
          text: asset.name,
          value: asset.url,
          help: asset.url
        };
      });
      const fetchedPages = !data.offset ? parsedData : this.state.fetchedPages.concat(parsedData);
      this.setState({
        fetchedPages
      });
      callback(null, {
        options: fetchedPages,
        pagination: {
          hasMore: data.offset + data.limit < data.totalCount,
          length: data.totalCount,
          offset: pagination.offset + 10
        }
      });
    }, () => {
      if (!this.mounted) {
        return;
      }
      callback(null);
    });
  }
  render() {
    const {
      url,
      onChange
    } = this.props;
    return /*#__PURE__*/_jsx(FormControl, {
      label: I18n.text(`RichTextLib.links.linkTypes.${LinkTypes.PAGE}.label`),
      marginBlockStart: "0",
      children: /*#__PURE__*/_jsx(Select, {
        autoload: true,
        searchable: true,
        cache: false,
        loadOptions: this.fetchPublishedContent,
        filterOptions: false,
        value: url,
        onSelectedOptionChange: ({
          target: {
            value: data
          }
        }) => {
          onChange({
            url: data.value,
            pageName: data.text
          });
        },
        placeholder: I18n.text(`RichTextLib.links.linkTypes.${LinkTypes.PAGE}.placeholder`)
      })
    });
  }
}
PageLinkField.propTypes = {
  url: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  fetchPages: PropTypes.func.isRequired
};